import pubsub from "@viewlift/pubsub"
import Cookies from 'js-cookie'
import { getDeviceId } from "../../../helpers"
import { callRequest } from "../../../Graphql/request"
import { setToken } from "./constant"
import trackEvent from "./analyticsMap"
import { FB_EVENTS } from "../../../helpers/analyticsMap"

let site = window?.app_data?.site?.siteInternalName
let apiBaseUrl =window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl

export const loginPhone = async ({phoneNumber,otpValue = null,key},id,type = 'initiate') => {
    let deviceId = getDeviceId();
    let utmCookie = Cookies.get('utm')
    let utmData = utmCookie && JSON.parse(utmCookie)

    if (type == "initiate") {
      let utmCookie = Cookies.get('utm')
      let utmData = utmCookie && JSON.parse(utmCookie)
      let variables = {
        "site": window?.app_data?.site?.siteInternalName,
        "device": "web_browser",
        "phoneNumber": phoneNumber,
        "campaign": (utmData && utmData.utm_campaign) || "",
        "campaignSource": (utmData && utmData.utm_medium) || "",
        "campaignMedium": (utmData && utmData.utm_medium) || "",
        "deviceName" : "",
        "action": "SIGNIN"
      }
      let cb = () => console.log("cb")
      return callRequest({type : "initiatePhone", variables,cb})
    }
    if (type == "validate") {
      let cb = () => console.log("cb")
      let variables = {
        "site": window?.app_data?.site?.siteInternalName,
        "key": key,
        "otp" : otpValue
      }
      return callRequest({type : "initiatePhoneValidate", variables,cb}).then( response => {
        let res = response?.identityAuthOtpValidate
          let token = res && {
            authorizationToken: res.authorizationToken,
            refreshToken: res.refreshToken
          }
          setToken(token)
          if(res.existingUser) {
            trackEvent('login', {method: "Phone Number"},null)
            pubsub.publish('FB-analytics',{eventType : FB_EVENTS.LOGIN ,payload : {platform: 'Web', registrationType: 'Native'},type : "FB"})
          } else {
            trackEvent('sign_up', {method: "Phone Number"},null)
            pubsub.publish('FB-analytics',{eventType : FB_EVENTS.COMPLETE_REGISTRATION ,payload : {platform: 'Web', registrationType: 'Native'},type : "FB"})
          }  
        localStorage.setItem('deviceId',deviceId)
        return response
      })
    }
}